export default __webpack_public_path__ + "static/media/hover3.c88e7e54.jpg";